import { type SymbolInfoUrlParam } from '#/types/additional-symbol-info.types';

export enum UrlParamsName {
  Debug = 'debug',
  LibDebug = 'lib-debug',

  Language = 'language',
  Theme = 'theme',
  Mode = 'mode',
  ChartSize = 'chart-size',
  AppId = 'app-id',

  Symbol = 'symbol',
  SymbolGroup = 'symbol-group',

  AccountNumber = 'account-number',
  AccountGroup = 'account-group',
  UserId = 'user-id',

  Ds = 'ds',
  ServerKey = 'server-key',
  Engine = 'engine',
  BrandName = 'brandName',

  CheckStartTimestamp = 'checkStartTimestamp',
  CheckEndTimestamp = 'checkEndTimestamp',

  FeatureOpenedPositions = 'openedPositions',
  FeaturePendingOrders = 'pendingOrders',
  FeatureTradingOperationsDrag = 'tradingOperationsDrag',
  FeatureHmr = 'hmr',
  FeatureHmrIcon = 'hmrIcon',
  FeatureDealsHistory = 'dealsHistory',
  FeaturePnl = 'pnl',
  FeatureSlTp = 'slTp',
  FeatureChartLegendValues = 'chartLegendValues',
  FeatureChartStateStorage = 'chart-state-storage',
  FeatureDefaultMovingAverages = 'default-moving-averages',
  FeatureChartTemplates = 'chartTemplates',

  Stream = 'stream',
}

export interface IUrlParamsService {
  getParamByName(name: UrlParamsName | SymbolInfoUrlParam): string | null;
  hasParamByName(name: UrlParamsName | SymbolInfoUrlParam): boolean;
  setParamByName<T extends string>(name: UrlParamsName | SymbolInfoUrlParam, value?: T): void;
  removeParamByName(name: UrlParamsName | SymbolInfoUrlParam): void;
}
